import * as angular from 'angular';
import { DirectiveDefinition } from './directiveDefinition';

/**
 * Meant to convert string to int for options in a select
 * https://docs.angularjs.org/api/ng/directive/select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting
 */
export const wtToNumberDirective: DirectiveDefinition = {
    directiveId: 'wtToNumber',
    restrict: 'A',
    require: ['ngModel'],
    link: function (scope, element, attrs, ngModel) {
        ngModel[0].$parsers.push((val: string) => {
            return parseInt(val, 10);
        });
        ngModel[0].$formatters.push(function (val) {
            return '' + val;
        });
    }
};